var $body = $("body");
var $cartToggle = $(".cart");
var $cartContainer = $("header").find("#cart-container");
var $addToCart = $(".add-to-cart");
var $addToCartQuantity = $(".add-to-cart-quantity");

var $accordionToggle = $("#accordionDelivery .card .card-header").find(
  ".toggle"
);
var $radioButtonCheck = $accordionToggle.find(".radio-button > .radio-inner");
$accordionToggle.on("click", function () {
  "use strict";
  var $radioButton = $(this).find(".radio-inner");
  $radioButtonCheck.removeClass("checked");
  if ($radioButtonCheck.hasClass("checked")) {
    $radioButtonCheck.removeClass("checked");
  } else {
    $radioButton.addClass("checked");
  }
});

var $accordionPaymentToggle = $("#accordionPayment .card .card-header").find(
  ".toggle"
);
var $radioButtonCheckPayment = $accordionPaymentToggle.find(
  ".radio-button > .radio-inner"
);
$accordionPaymentToggle.on("click", function () {
  "use strict";
  var $radioButton = $(this).find(".radio-inner");
  $radioButtonCheckPayment.removeClass("checked");
  if ($radioButtonCheckPayment.hasClass("checked")) {
    $radioButtonCheckPayment.removeClass("checked");
  } else {
    $radioButton.addClass("checked");
  }
});

var $paymentToggle = $("#checkout").find(".payment-toggle");
var $paymentContainer = $("#checkout").find("#order-details");
$paymentToggle.on("click", function () {
  $(this).toggleClass("toggle");
  $paymentContainer.toggleClass("expanded");
  $body.toggleClass("overflow-hidden");
});

(function () {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      var forms = document.getElementsByClassName("needs-validation");
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
              $(form).addClass("has-errors");
            } else {
              $(form).removeClass("has-errors");
              $(form).addClass("submitting");
              $(".list-loader").show();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
})();

var Cart = function (container, type) {
  this._body = $("body");
  this._addButton = $(".add-to-cart-button");
  this._addQuantityInput = $(".add-to-cart-quantity");
  this._addOptions = $(".product-options");
  this._cartContainer = container;
  this._type = type;
  this.initialize();
};
Cart.prototype = {
  _body: null,
  _addButton: null,
  _addOptions: null,
  _addQuantityInput: null,
  _changeTimeout: null,
  _changeRequest: null,
  _cartContainer: null,
  _type: null,
  initialize: function () {
    var self = this;

    this._addButton.on("click", function () {
      var options = [];
      $(".list-loader").show();

      if (self._addOptions.length > 0) {
        var valid = true;
        self._addOptions.each(function () {
          if ($(this).find("input:checked").val() != null) {
            options.push($(this).find("input:checked").val());
          } else if ($(this).find("input.current-size").length > 0) {
            options.push($(this).find("input.current-size").val());
          } else {
            $(this).addClass("error");
            valid = false;
          }
        });

        if (!valid) {
          return false;
        }
      }

      var button = $(this);

      $.post("/cart/add", {
        id: $(this).data("id"),
        qty:
          self._addQuantityInput.length == 0 ? 1 : self._addQuantityInput.val(),
        max_order_amount: 1,
      })
        .done(function (html) {
          getStatus();

          getRedirect();
        })
        .fail(function (xhr, status, error) {
          $(".cart-error").addClass("show");
          $(".list-loader").hide();
        });

      return false;
    });

    self._body.find(".side-cart-overlay").on("click", function () {
      self._body.removeClass("overlay");
      self._cartContainer.removeClass("show");
    });
  },
};

new Cart($(".side-cart-placeholder"), "");

getStatus();

function getStatus() {
  $.get("/cart/status", function (response) {
    var data = JSON.parse(response);

    $(".icon-cart-full .count")
      .show()
      .html(data.cart > 0 ? data.cart : "");
  });
}

function getRedirect() {
  $.get("/cart/add", function (response) {
    window.location.href = response;
  });
}

var Checkout = function (container, type) {
  this.initialize();

  var checkoutValue = $(".checkout-summary-placeholder").data("price");
  var cartContents = [];
  $(".order-products-list .product").each(function () {
    cartContents.push({
      item_id: $(this).data("productcode"),
      item_name: $(this).data("title"),
      discount: $(this).data("discount"),
      price: $(this).data("price"),
      quantity: $(this).data("quantity"),
    });
  });
};
Checkout.prototype = {
  initialize: function () {
    var self = this;

    $(".form-check-input.payment-input").prop("checked", true);

    $("#billing_country_id").on("change", function () {
      if ($(this).val() === "869dd468-988c-4744-b95d-4a3bc58d559f") {
        $(".form-check-label .cash-on-delivery").removeAttr("disabled");
        $(".payment-country-info").hide();
      } else {
        $(".form-check-label .cash-on-delivery").attr("disabled", "disabled");
        $(".payment-country-info").show();
        if ($(".form-check-input.cash-on-delivery").is(":checked")) {
          $(".form-check-input.cash-on-delivery").prop("checked", false);
        }
      }

      if ($("#delivery-checkbox").is(":checked")) {
        return;
      }
      self.changeDeliveryCountry();
    });

    $("#delivery input, #payment input").on("change", function () {
      self.saveDeliveryChoice(
        $("input[name=payment_type_id]:checked").val(),
        $("input[name=delivery_type_id]:checked").val(),
        $("select[name=billing_country_id]").val()
      );
    });

    self.changeDeliveryCountry();
    if ($("#delivery-checkbox").is(":checked")) {
      $(".delivery-address").show().find("input").prop("required", true);
    }

    $.get("/cart/checkout-summary", function (html) {
      self.applySummary(html);
    });
  },
  changeDeliveryCountry: function () {
    var country = $("#billing_country_id");
    if ($("#delivery-checkbox").is(":checked")) {
      country = $("#delivery_country_id");
    }
    var countryId = country.val();

    this.saveDeliveryChoice(
      $("input[name=payment_type_id]:checked").val(),
      $("input[name=delivery_type_id]:checked").val(),
      countryId
    );
  },
  saveDeliveryChoice: function (payment, delivery, country) {
    var self = this;
    $.post(
      "/cart/checkout-delivery",
      {
        payment_type_id: payment != null ? payment : null,
        delivery_type_id: delivery != null ? delivery : null,
        country_id: country != null ? country : null,
      },
      function (html) {
        self.applySummary(html);
      }
    );
  },
  applySummary: function (html) {
    var self = this;
    $(".checkout-summary-placeholder").html(html);

    if (!self.executed) {
      self.executed = true;
      var contentIds = [];
      var contents = [];
      $("#order-details .product").each(function () {
        contentIds.push($(this).data("productcode"));
        contents.push({
          id: $(this).data("productcode"),
          quantity: $(this).data("quantity"),
        });
      });
    }
  },
};

if ($("#checkout").length > 0) {
  new Checkout();
}
